import { alpha, Interpolation } from '@mui/material';
import { theme } from './theme.ts';

/**
 * Add any custom classes here, provides access to the theme
 * @param theme
 * @constructor
 */

export const SiteStyles: Interpolation<typeof theme> = (theme) => ({
  ['.main-header']: {
    color: 'white',
    textShadow: '-3px 3px 0 #65A6B2',
    textTransform: 'uppercase',
    textAlign: 'center',
    letterSpacing: 8,
    fontWeight: '800 !important',
  },
  ['div#root .overview-header-card']: {
    width: '100%',
    minHeight: 120,
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    background: `linear-gradient(${alpha(theme.palette.background.default, 0.7)}, ${alpha(theme.palette.background.default, 0)})`,
    borderRadius: 0.2,
    justifyContent: 'space-between',
    '.MuiTypography-root:first-of-type': {
      display: 'flex',
      gap: theme.spacing(2),
    },
  },
  ['div#root .overview-header-gradient']: {
    background: `linear-gradient(${alpha(theme.palette.background.default, 0.5)} 60%, ${alpha(theme.palette.background.default, 0.1)} 100%)`,
  },
  ['div#root .paper']: {
    backgroundImage: 'url(/img/paper-texture.png)',
    backgroundRepeat: 'repeat',
  },
  ['*::-webkit-scrollbar']: {
    width: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
  },
  ['*::-webkit-scrollbar-thumb']: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.info.main,
  },
  ['*::-webkit-scrollbar-track']: {
    backgroundColor: 'transparent',
  },
  ['.progress-bar']: {
    display: 'flex',
    flexGrow: 1,
    height: theme.spacing(5),
    backgroundColor: theme.palette.primary.dark,
    overflow: 'hidden',
    position: 'relative',
    borderRadius: theme.shape.borderRadius * 0.25,
  },
});
